import React from "react";
import ShippingItem from "./ShippingItem";

const ShippingsList = ({
  shippings,
  invoiceItems,
  shippingMethods,
  printShipping,
  isEditable,
  printCopy,
}) => {
  console.log(shippings, invoiceItems);
  return (
    <>
      {shippings.map((s, ix) => {
        return (
          <ShippingItem
            printCopy={printCopy}
            shipping={s}
            printShipping={printShipping}
            isEditable={isEditable}
            shippingMethods={shippingMethods}
            key={ix}
            invoiceItems={invoiceItems.filter((ii) =>
              s.items.map((i) => i.skuID).includes(ii.skuId)
            )}
          />
        );
      })}
    </>
  );
};

export default ShippingsList;
